import { render, staticRenderFns } from "./InformacionGeneral.vue?vue&type=template&id=2fba1a36&"
import script from "./InformacionGeneral.vue?vue&type=script&lang=ts&"
export * from "./InformacionGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports